<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import { locale, locales } from 'svelte-i18n'
    import { _ } from 'svelte-i18n'
    import {clientSettings, customerSettings} from "../../../stores/api";
    import Select from "../../shared/Select.svelte";
    import {onMount} from "svelte";
    import {app} from "../../../stores/app";
    import { debug } from '../../../stores/store';
    import { setCookie } from '../../utilities/cookie';

    export let updateClient: () => void;

    let items: {id: string, label: string}[] = [];

    locale.subscribe(value => {
        console.debug('saving setting locale:', value);
        if (typeof value === 'string') {
            value = value.toLowerCase();
            $clientSettings.locale = value;
            // Set cookie for backend i18n (with domain to share across subdomains)
            setCookie('ln', value);
            updateClient();
        }
    });

    onMount( () => {
        items = $locales.filter(locale => $app.account.getEnabledLocales().includes(locale)).map(locale => {
            return {
                id: locale,
                label: $app.account.getAvailableLocales().find(l => l?.id===locale)?.name.toLowerCase() || locale
            }
        });
        console.log('available locales for select:', items, $app.account.getAvailableLocales());
    })

</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('Language')}</div>
    <div slot="content">
        {#if $debug}
            <div>Current locale: {$locale}</div>
            <div>{JSON.stringify($app.account.getAvailableLocales())}</div>
        {/if}
        <Select selected={$locale} {items} onChange={(s)=>{locale.set(s); updateClient(); }}/>
    </div>
</TemplateSettingsGeneral>

<style>
    .settings-select{
        box-sizing: border-box;
        width: 100%;
        padding: 3px 6px;
        margin: 0 3px;
        background-color: #ffffff;
        border: 0;
        border-radius: 4px;
    }
</style>